import { useContext, useState } from 'react';
import { Card, Container, CardHeader, Typography, Button, CardContent, Grid, CircularProgress } from '@material-ui/core';
import { LockOpenOutlined as UnLockIcon } from '@material-ui/icons';
import { authContext } from 'helpers/services';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';
import { TextField } from 'formik-material-ui';
import { useLocation } from 'react-router';


let ChangePassword = () => {
    let location = useLocation<any>();

    let authService = useContext(authContext);

    let [isLoading, setLoading] = useState(false);

    let changePasswordSchema = yup.object().shape({
        clientId: yup.string().required('ClientId not set').default(''),
        clientSecret: yup.string().required('Client secret not set').default(''),
        newPassword: yup.string().required('Please set new password').default(''),
        newPasswordConfirm: yup.string()
            .oneOf([yup.ref('newPassword'), null], 'Passwords do not match')
            .required('You have to confirm new password')
            .default('')
    })


    return (
        <Container maxWidth="sm">
            <Card elevation={0}>
                <CardHeader
                    disableTypography
                    title={<Typography variant="h4">You must change password before login</Typography>}
                    subheader={<Typography variant="h5">You have used temporary password that need to be changed</Typography>}
                />

                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs>
                            <Formik
                                initialValues={{
                                    ...changePasswordSchema.getDefault(),
                                    clientId: location.state?.clientId || '',
                                    clientSecret: location.state?.clientSecret || ''
                                }}
                                validationSchema={changePasswordSchema}
                                onSubmit={async (values, action) => {
                                    setLoading(true);
                                    let res = await authService.signInAndChangePassword(values.clientId, values.clientSecret, values.newPassword);
                                    if (res === false) {
                                        action.setSubmitting(false);
                                        setLoading(false);
                                    }
                                }}
                            >
                                <Form>
                                    <Grid container alignItems="center">
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                name="newPassword"
                                                label="New Password"
                                                variant="outlined"
                                                fullWidth
                                                type="password"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                name="newPasswordConfirm"
                                                label="Confirm new Password"
                                                variant="outlined"
                                                fullWidth
                                                type="password"
                                            />
                                        </Grid>
                                        <Grid item xs>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading}
                                                startIcon={isLoading ? <CircularProgress size={20} /> : <UnLockIcon />}
                                            >
                                                Change password
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </Formik>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Container>
    )
}

export default ChangePassword;